export default __webpack_public_path__ + "static/media/stamp_with_sign.f58021f9.png";